import { put, select, takeLatest } from 'redux-saga/effects'
import { getCrewSelector } from '../../crew/selectors'
import { ICrewState } from '../../crew/store/crew.types'
import { HomeConstants } from '../../home/store/home.constants'
import * as actions from '../store/tripInformation.actions'
import { IConfigurationsState } from '../../configurations/store/configurations.types'
import { getConfigurationsSelector } from '../../configurations/selectors/configurations.selector'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { supportsMaxAlt } from '../utils/tripInformation.util'

export function* setSetShiftInformation() {
  const configurationsState: IConfigurationsState = yield select(getConfigurationsSelector)
  const { serviceConfig } = configurationsState
  const crewState: ICrewState = yield select(getCrewSelector)
  const vehicle = crewState.vehicleOptions?.find((unit) => unit?.id === crewState.vehicle?.id) ?? crewState.vehicle
  yield put(actions.setBaseOption(crewState.base))
  yield put(actions.setShift(crewState.shift))
  yield put(actions.setStaffingLevel(crewState.staffingLevel))
  yield put(actions.setUnitEquipment(crewState.unitEquipment))
  yield put(actions.setRegTailNumberOption(crewState.registrationTailNumber))
  yield put(actions.setUnitOption(vehicle))
  if (vehicle) {
    if (supportsMaxAlt(vehicle) && vehicle.defaultAltitude !== null) {
      yield put(actions.setMaxAlt(vehicle.defaultAltitude))
    } else {
      yield put(actions.setMaxAlt(''))
      yield put(actions.setFlightPlan(null))
    }
  } else {
    yield put(actions.setMaxAlt(''))
    yield put(actions.setFlightPlan(null))
  }

  yield put(actions.setVehicleMileageLpm(serviceConfig.PR_LPM))
  yield put(actions.setVehicleMileageOdom(serviceConfig.PR_ODOM))
}
export function* setSetShiftInformationSaga() {
  yield takeLatest([HomeConstants.SET_NEW_PCR], performWithMutexHOG, setSetShiftInformation)
}
